export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()

export const getFileExtension = (fileName: string) => {
  const parts = fileName.split('.')
  return parts[parts.length - 1]
}

export const toTitleCase = (str) => {
  return str.replace(/\b\w+/g, function (s) {
    return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase()
  })
}
